import MasterRateClassActionDropdown from './MasterRateClassActionDropdown';

const RateClassNameCell = ({ row }) => (
  <span className="d-inline-flex align-items-center">
    <span style={{ width: 18, display: 'inline-flex', justifyContent: 'center' }}>
      {row.original.isResidential ? (
        <i className="uil uil-home-alt" title="Residential Rate Class" aria-label="Residential Rate Class" role="img" />
      ) : null}
    </span>
    <span className="ms-1">{row.original.rateClassName}</span>
  </span>
);

export const createMasterRateClassColumns = (onEdit, onDelete) => [
  {
    id: 'rateClassName',
    header: 'Rate Class',
    accessorKey: 'rateClassName',
    cell: RateClassNameCell,
  },
  {
    id: 'rateCode',
    header: 'Rate Code',
    accessorKey: 'rateCode',
  },
  {
    id: 'rateClassification',
    header: 'Rate Classification',
    accessorKey: 'rateClassification',
  },
  {
    id: 'actions',
    header: 'Action',
    accessorKey: 'rateClassId',
    enableSorting: false,
    cell: ({ row }) => <MasterRateClassActionDropdown row={row.original} onEdit={onEdit} onDelete={onDelete} />,
  },
];
